import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';

import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { F1, Option } from '@client/new/helpers/types';

type DropDownVariant = 'inherit' | 'primary';
export type DropDownProps<T> = {
  onChange: F1<T>;
  items: Array<Option<T>>;
  value: T;
  variant?: DropDownVariant;
  hideIcon?: boolean;
};

export const DropDown = <T,>({
  variant = 'primary',
  ...p
}: DropDownProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Box className="flex gap-2 items-center" onClick={handleClick}>
        <Typography color={variant} fontSize="inherit" fontWeight="inherit">
          {p.items.find((v) => v.value === p.value)?.label || '---'}
        </Typography>

        <IconButton
          size="small"
          className={classNames('py-0', {
            ['invisible w-0 px-0']: p.hideIcon,
            'px-1.5': !p.hideIcon,
          })}
          color={variant}
          sx={{ width: 24, height: 24 }}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            className={classNames('w-3 transition-transform', {
              'rotate-180': open,
            })}
          />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            maxHeight: 300,
          },
        }}
      >
        {p.items.map((i, index) => (
          <MenuItem
            key={index}
            selected={i.value === p.value}
            onClick={() => {
              handleClose();
              p.onChange(i.value);
            }}
          >
            {i.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
